/**
 * LISTE KUNYESI — sunucu ve arayuz AYNI sekli kullanir (G-UYG-11)
 *
 * ================================================================
 * NEDEN BURADA — ELLE YAZILAN AYNA AYRISTI
 * ================================================================
 * Bu sekil once iki yerde AYRI AYRI yazilmisti: sunucuda
 * `apps/api/src/common/liste.ts`, panelde `apps/panel/src/api.ts`.
 * Ayni gun (04.09.2026) sunucuya `toplam: number | null` eklendi ve
 * panel tipi `number` kaldi. Sonucu ucluydu ve UCU DE SESSIZDI:
 *
 *   1. Tip YALAN SOYLUYORDU: uc `null` donerken tip `number` vaat
 *      ediyordu. TypeScript kimseyi uyarmaz.
 *   2. `k.toplam.toLocaleString()` calisma aninda patlardi.
 *   3. Davranis ayristi: "toplam olculemediyse sinira dayanmak tek
 *      basina uyari sebebi" kurali panelde YOKTU — kesilmis bir
 *      listeyi TAM gibi gosterirdi.
 *
 * Ucuncusu en sinsisi: ikinci hata birincisini MASKELIYORDU. Panelin
 * `listeKesintiMetni`si erken cikiyordu, o yuzden patlama gorunmuyordu.
 *
 * Sekil ve KURAL artik tek yerde. Iki taraf da buradan okuyor; ayrisma
 * icin once bu dosyanin degismesi gerekiyor ve o zaman iki taraf
 * birden derlenir.
 */

export interface ListeKunyesi {
  /**
   * Olcute uyan kayit sayisi — kirpma UYGULANMADAN.
   *
   * `null` = OLCULEMEDI, sifir DEGIL. Bazi listeler veritabanindan
   * cektikten SONRA bellekte suzuluyor (duyurularin hedef kitlesi
   * gibi: gorunurluk kurali SQL'e cevrilemiyor). Orada `count()`
   * kullanicinin GOREMEYECEGI kayitlari sayardi ve ekran olmayan
   * kayitlar vaat ederdi.
   *
   * Ekran `null` iken "0 kayit" YAZMAMALI — bu depodaki
   * "olculmedi ≠ %0" kuralinin ayni hali.
   */
  toplam: number | null;
  /** Bu yanitta donen satir sayisi */
  gosterilen: number;
  /** Ucun donebilecegi en fazla satir */
  sinir: number;
}

/**
 * Liste kesildi mi — SUNUCU VE ISTEMCI AYNI SORUYU AYNI BICIMDE
 * sorsun diye burada.
 *
 * `gosterilen >= sinir` (esitlik degil `>=`): tam sinira dayanan bir
 * liste kesilmis SAYILIYOR.
 *
 * TOPLAM OLCULEMEDIYSE sinira dayanmak TEK BASINA yetiyor: devamin
 * olup olmadigini bilmiyoruz ve bilmedigimizde "kesilmedi" demek,
 * kesilmis bir listeyi TAM gibi gostermek olur. Fazladan bir uyari,
 * eksik bir uyaridan iyidir.
 */
export function listeKesildiMi(k: ListeKunyesi): boolean {
  if (k.toplam === null) return k.gosterilen >= k.sinir;
  return k.gosterilen >= k.sinir && k.toplam > k.gosterilen;
}

/**
 * Kullaniciya gosterilecek kesinti metni; kesilmediyse `null`.
 *
 * Toplam OLCULEMEDIYSE sayi yazilmiyor — uydurulmus bir toplam,
 * eksik bir listeyi tam gostermekten daha kotu olurdu.
 */
export function listeKesintiMetni(k: ListeKunyesi, birim = "kayıt"): string | null {
  if (!listeKesildiMi(k)) return null;
  if (k.toplam === null) return `İlk ${k.gosterilen} ${birim} gösteriliyor · devamı olabilir`;
  return `${k.toplam.toLocaleString("tr-TR")} ${birim} · ilk ${k.gosterilen} gösteriliyor`;
}

/**
 * Kunyeyi kurar — `toplam`i CAGIRAN olcuyor (`count({ where })`),
 * cunku `where` her ucta farkli.
 *
 * GOSTERILEN, TOPLAMI GECEMEZ: gecerse iki sorgu arasinda kayit
 * silinmistir. `toplam`i buyutmek yerine tavanliyoruz — "199
 * kayittan 200'u" yazan bir ekran kullaniciya sistemin bozuk oldugunu
 * dusundururdu.
 */
export function listeKunyesi(
  toplam: number | null,
  gosterilen: number,
  sinir: number,
): ListeKunyesi {
  if (toplam === null) return { toplam: null, gosterilen, sinir };
  return { toplam: Math.max(toplam, gosterilen), gosterilen, sinir };
}
